import React from "react";

// Local
import CustomCard from "./CustomCard";
import { Box, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { Container, Text } from "@jds/core";

export default function AuthCard(props) {
  return (
    <CustomCard
      radius="32px"
      sx={{ padding: "80px 48px 48px", maxWidth: "484px" }}>
      <Container direction="column" gap={40}>
        <Text appearance="heading-m">
          Sign {props.title} <br /> to JioPhotos{" "}
        </Text>
        <Text appearance="body-m" color="primary_grey_80">
          Capture, organize, and share your events memories effortlessly.
        </Text>
      </Container>
      {props.children}
      <Container
        direction="row"
        style={{
          marginTop: "24px",
          flexWrap: "wrap",
          gap: "2px 7px",
        }}>
        <Text appearance="body-xxs" color="primary_grey_80">
          By continuing, you agree to our{" "}
        </Text>
        <NavLink
          to="https://www.jio.com/jcms/en-in/jiophotos-terms-and-conditions/"
          target="_blank">
          <Text appearance="body_xxs_bold" color="primary_grey_80">
            Terms of Service
          </Text>
        </NavLink>{" "}
        <Text appearance="body-xxs" color="primary_grey_80">
          and{" "}
        </Text>
        <NavLink
          to="https://www.jio.com/jcms/en-in/jiophotos-privacy-policy/"
          target="_blank">
          <Text appearance="body_xxs_bold" color="primary_grey_80">
            Privacy & Legal Policy
          </Text>
        </NavLink>
        {/* <NavLink to={"/"}>
          <Text appearance="body_xxs_bold" color="primary_grey_80">
            Legal Policy
          </Text>
        </NavLink> */}
      </Container>
    </CustomCard>
  );
}
